import * as React from 'react';
import { ProgramBenefitsPayload } from '~/common/types/types';
import { SectionLayout } from '~/components/common/common';
import { ProgramBenefitsList } from './components/components';
import * as styles from './program-benefits.module.scss';

const SECTION_CLASSES = {
  section: styles.section,
  wrapper: styles.wrapper,
};

type Props = {
  payload: ProgramBenefitsPayload;
};

const ProgramBenefits: React.FC<Props> = ({ payload }) => {
  const { items } = payload;

  return (
    <SectionLayout classes={SECTION_CLASSES}>
      <h2 className="visually-hidden">Program benefits</h2>
      <ProgramBenefitsList items={items} />
    </SectionLayout>
  );
};

export { ProgramBenefits };
